import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import SEO from "../../components/SEO";
import { Collapse, makeStyles } from "@material-ui/core";
import { useInView } from "react-intersection-observer";
import { motion, transform } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";

import heroSectionBg from "../../images/v4/aiFeatures/aiTextModification/images/heroSectionBg.png";
import heroSectionImgBg from "../../images/v4/aiFeatures/aiTextModification/images/heroSectionImgBg.png";
import heroSectionImg2 from "../../images/v4/aiFeatures/aiTextModification/images/heroSectionImg2.webp";
import tabsSectionBg from "../../images/v4/aiFeatures/aiTextModification/images/tabsSectionBg.png";
import accordianTabsBg from "../../images/v4/aiFeatures/aiChatbot/images/accordianTabsBg.png";
import growingBusinessBg from "../../images/v4/aiFeatures/aiChatbot/images/growingBusinessBg.png";
import flipSectionBg from "../../images/v4/aiFeatures/aiTextModification/images/flipSectionBg.png";
import benefitSection1Bg from "../../images/v4/aiFeatures/aiTextModification/images/benefitSection1Bg.png";
import faqBg from "../../images/v4/aiFeatures/aiTextModification/images/faqBg.png";

import realWorldImg1 from "../../images/v4/aiFeatures/aiTextModification/images/realWorldImg1.webp";
import realWorldImg2 from "../../images/v4/aiFeatures/aiTextModification/images/realWorldImg2.webp";
import realWorldImg3 from "../../images/v4/aiFeatures/aiTextModification/images/realWorldImg3.webp";
import realWorldImg4 from "../../images/v4/aiFeatures/aiTextModification/images/realWorldImg4.webp";
import realWorldImg5 from "../../images/v4/aiFeatures/aiTextModification/images/realWorldImg5.webp";

import benefitIcon1 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon1.svg";
import benefitIcon2 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon2.svg";
import benefitIcon3 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon3.svg";
import benefitIcon4 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon4.svg";
import benefitIcon5 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon5.svg";
import benefitIcon6 from "../../images/v4/aiFeatures/aiSentiment/icons/benefitIcon6.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import heroIcon1 from "../../images/v4/aiFeatures/aiTextModification/icons/heroIcon1.svg";
import heroIcon2 from "../../images/v4/aiFeatures/aiTextModification/icons/heroIcon2.svg";
import heroIcon3 from "../../images/v4/aiFeatures/aiTextModification/icons/heroIcon3.svg";
import assistAi from "../../images/v4/aiFeatures/aiChatbot/images/aiIcon.png";

import benefit1Icon1 from "../../images/v4/aiFeatures/aiTextModification/icons/benefit1Icon1.svg";
import benefit1Icon2 from "../../images/v4/aiFeatures/aiTextModification/icons/benefit1Icon2.svg";
import benefit1Icon3 from "../../images/v4/aiFeatures/aiTextModification/icons/benefit1Icon3.svg";
import benefit1Icon4 from "../../images/v4/aiFeatures/aiTextModification/icons/benefit1Icon4.svg";

import benefit1Img from "../../images/v4/aiFeatures/aiTextModification/images/benefit1Img.webp";

import singleCardImg from "../../images/v4/aiFeatures/aiTextModification/images/singleCardImg.webp";

import flipImg1 from "../../images/v4/aiFeatures/aiTextModification/images/flipImg1.webp";
import flipImg2 from "../../images/v4/aiFeatures/aiTextModification/images/flipImg2.webp";
import flipImg3 from "../../images/v4/aiFeatures/aiTextModification/images/flipImg3.webp";
import flipImg4 from "../../images/v4/aiFeatures/aiTextModification/images/flipImg4.webp";
import flipImg5 from "../../images/v4/aiFeatures/aiTextModification/images/flipImg5.webp";

import swiperIcon1 from "../../images/v4/aiFeatures/aiTextModification/icons/swiperIcon1.svg";
import swiperIcon2 from "../../images/v4/aiFeatures/aiTextModification/icons/swiperIcon2.svg";
import swiperIcon3 from "../../images/v4/aiFeatures/aiTextModification/icons/swiperIcon3.svg";
import swiperIcon4 from "../../images/v4/aiFeatures/aiTextModification/icons/swiperIcon4.svg";

const useStyles = makeStyles((theme) => ({
   commonHeroSection: {
      backgroundImage: `url(${heroSectionBg})`,
      backgroundPosition: "bottom",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      position: "relative",
   },
   heroSection: {
      paddingTop: "120px",
      position: "relative",
      "@media only screen and (max-width: 600px)": {
         paddingTop: "0",
         paddingBottom: "0",
      },
   },
   heroSectionImgSection: {
      backgroundImage: `url(${heroSectionImgBg})`,
      backgroundPosition: "top",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      position: "relative",
      padding: "40px 0",
      "& img": {
         width: "100%",
      },
   },
   boxes: {
      marginTop: "56px",
      width: "100%",
      display: "flex",
      gap: "24px",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         marginTop: "20px",
         flexDirection: "column",
         gap: "12px",
      },
   },
   box: {
      gap: "16px",
      width: "25%",
      padding: "24px",
      borderRadius: "12px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backdropFilter: "blur(50px)",
      "& p": {
         width: "100% !important",
      },
      "&:first-child": {
         background:
            "linear-gradient(180deg, #009A99 0%, #104F4F 50%, #021D1D 100%)",
      },
      "&:nth-child(2)": {
         background:
            "linear-gradient(180deg, #9E5AD5 0%, #4F1F75 49.52%, #021D1D 100%)",
      },
      "&:last-child": {
         background:
            "linear-gradient(180deg, #208EEC 0%, #174C79 48.75%, #021D1D 97.5%)",
      },
      "@media only screen and (max-width: 600px)": {
         flex: "1",
         width: "100%",
         padding: "10px",
         justifyContent: "center",
         alignItems: "center",
         gap: "20px",
      },
   },
   heroSectionContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      margin: "0 auto",
      gap: "24px",
      textAlign: "center",
      "& h1": {
         width: "70%",

         "@media only screen and (max-width: 600px)": {
            width: "100%",
         },
      },
      "& p": {
         width: "70%",
         "@media only screen and (max-width: 600px)": {
            width: "100%",
         },
      },
      "& span": {
         background: "linear-gradient(93deg, #058ED6 4.84%, #00BFA5 99.8%)",
         WebkitBackgroundClip: "text",
         WebkitTextFillColor: "transparent",
         display: "inline-flex",
         alignItems: "baseline",
         justifyContent: "flex-start",
         gap: "5px",
         "& img": {
            height: "50px",
            width: "50px",
         },
         "@media only screen and (max-width: 1200px)": {
            "& img": {
               height: "30px",
               width: "30px",
            },
         },
         "@media only screen and (max-width: 600px)": {
            "& img": {
               height: "30px",
               width: "30px",
            },
         },
      },
   },
   detailSection: {
      background: "linear-gradient(180deg, #210538 0%, #104F4F 100%)",
   },
   detailCard: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      "@media only screen and (max-width: 600px)": {
         flexDirection: "column-reverse",
         gap: "40px",
      },
   },
   detailCardLeft: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      gap: "20px",
      width: "38%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         "&.card2": {
            width: "100%",
         },
      },
   },
   detailCardRight: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      gap: "20px",
      width: "48%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   accordianTabs: {
      backgroundImage: `url(${accordianTabsBg})`,
      backgroundPosition: "top",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      position: "relative",
      "& .headercenterContainer": {
         display: "flex",
         flexDirection: "column",
         alignItems: "center",
         justifyContent: "center",
         marginBottom: "64px",
         textAlign: "center",
         gap: "30px",
         "& h2": {
            width: "100%",
         },
         "& p": {
            width: "100%",
         },
         "@media (max-width:768px)": {
            flexDirection: "column",
            gap: "18px",
            marginBottom: "55px",
            "& h2": {
               width: "100%",
            },
            "& p": {
               width: "100%",
            },
         },
      },
   },
   absoulteCard: {
      position: "absolute",
      margin: "0 auto",
      width: "100%",
      top: "-20%",
      "@media only screen and (max-width: 600px)": {
         top: "-16%",
      },
   },
   tabsSection: {
      backgroundImage: `url(${tabsSectionBg})`,
      backgroundPosition: "top",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      position: "relative",
      paddingTop: "300px",
      "& .centerContainer": {
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "32px",
         width: "90%",
         margin: "0 auto",
         textAlign: "center",
      },
      "& $supportBox": {
         position: "absolute",
         top: "-530px",
         "@media only screen and (max-width: 600px)": {
            top: "-800px",
            marginTop: 0,
         },
      },
      "@media only screen and (max-width: 600px)": {
         paddingTop: "120px",
         "& .centerContainer": {
            width: "100%",
         },
      },
   },
   tabsContainer: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "8px",
      border: "2px solid #DBDBDB",
      borderRadius: "40px",
      background: "#fff",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         gap: "10px",
         padding: "5px",
         overflow: "auto",
         "&::-webkit-scrollbar": {
            display: "none",
         },
      },
   },
   tab: {
      width: "33%",
      background: "",
      padding: "18px",
      background: "transparent",
      borderRadius: "40px",
      background: "transparent",
      transition: "0.3s ease",
      cursor: "pointer",
      "&.active": {
         color: "white",
         background:
            "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
      },
      "@media only screen and (max-width: 600px)": {
         minWidth: "max-content",
         padding: "10px 15px",
      },
   },
   tabCard: {
      marginTop: "65px",
      gap: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      "@media only screen and (max-width: 600px)": {
         marginTop: "30px",
         flexDirection: "column",
      },
   },
   tabCardLeftContainer: {
      width: "50%",
      display: "flex",
      gap: "40px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      "@media only screen and (max-width: 600px)": {
         gap: "20px",
         width: "100%",
      },
   },
   tabCardRightContainer: {
      width: "50%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },

   tabListContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "30px",
      marginTop: "50px",
      "@media only screen and (max-width: 600px)": {
         gap: "15px",
         marginTop: "20px",
      },
   },
   tabListItem: {
      display: "flex",
      width: "100%",
      margin: "0 auto",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "15px",
      position: "relative",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         gap: "15px",
         alignItems: "flex-start",
      },
   },
   tabListItemContent: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      gap: "10px",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   wpFaq: {
      // paddingTop: "120px",

      "@media only screen and (max-width: 600px)": {
         "& section": {
            padding: "0px 0 0 !important",
         },
      },
   },
   commonPageFooterSection: {
      background:
         " linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
      "& .centerContainer": {
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "32px",
         width: "100%",
         margin: "0 auto",
         textAlign: "center",
      },
      "@media only screen and (max-width: 600px)": {
         "& .centerContainer": {
            width: "100%",
         },
      },
   },
   partnerSlide: {
      width: "144px !important",
      "& img": {
         width: "144px",
         filter: "brightness(1)",
      },
      "@media only screen and (max-width: 600px)": {
         width: "max-content !important",
         "& img": {
            width: "100px",
         },
      },
   },
   partnerSlider: {
      padding: "10px 0 60px !important",
      "@media only screen and (max-width: 600px)": {
         paddingBottom: "40px !important",
      },
   },
   growingBusiness: {
      backgroundImage: `url(${growingBusinessBg})`,
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      paddingBottom: "80px",
      position: "relative",
      "& .header": {
         width: "55%",
         display: "flex",
         flexDirection: "column",
         justifyContent: "flex-start",
         alignItems: "flex-start",
         textAlign: "left",
         gap: "32px",
      },
      "& $featureContainer": {
         gap: "20px",
      },
      "@media only screen and (max-width: 600px)": {
         paddingBottom: "50px",
         "& .header": {
            width: "100%",
         },
      },
   },
   broadcastContainerInner: {
      gap: "30px",
      width: "100%",
      display: "flex",
      padding: "0 16rem 0rem 16rem",
      paddingTop: "10px  !important",
      paddingBottom: "10px  !important",
      alignItems: "stretch",
      justifyContent: "flex-start",
      "& swiper-wrapper": {
         alignItems: "stretch !important",
      },

      "& $featureContainer": {
         width: "31%",
         height: "auto  !important",
      },
      "@media only screen and (max-width: 600px)": {
         padding: "0 15px !important",
         paddingBottom: "10px !important",
      },
      "@media only screen and (min-width: 1900px)": {
         paddingLeft: "23rem !important",
         paddingRight: "23rem !important",
      },
   },
   featureContainer: {
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "32%",
      gap: "22px",
      boxShadow: "0px 0px 16px #C1D7DB66",
      borderRadius: "16px",
      background: "#fff",
      padding: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "& p": {
         width: "90%",
      },
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         "& p": {
            width: "100%",
         },
      },
   },
   trustedSection: {
      "& .trustedHeading": {
         textAlign: "center",
      },
   },
   benefitSection1: {
      // backgroundImage: `url(${benefitSection1Bg})`,
      // backgroundPosition: "top",
      // backgroundSize: "cover",
      // backgroundRepeat: "no-repeat",
      background: "linear-gradient(180deg, #210538 0%, #011C33 100%)",
      "& .centerContainer": {
         display: "flex",
         flexDirection: "column",
         justifyContent: "center",
         alignItems: "center",
         gap: "32px",
         width: "70%",
         margin: "0 auto",
         textAlign: "center",
         // textAlign: "center",
         "& h2": {
            flex: 1,
         },
         "& p": {
            flex: 1,
         },
      },
      "@media only screen and (max-width:  768px)": {
         "& .centerContainer": {
            width: "100%",
         },
      },

      "& .benefits": {
         display: "flex",
         justifyContent: "space-between",
         gap: "20px",
         margin: "60px 0",
         marginBottom: "0",
         "& .imageColumn": {
            width: "94.5%",

            "& img": {
               width: "100%",
            },
         },

         "& .featureColumn": {
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            width: "92%",
            "& .featureContainer": {
               backgroundSize: "cover",
               backgroundPosition: "center",
               backgroundRepeat: "no-repeat",
               width: "100%",
               gap: "22px",
               boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.15)",
               borderRadius: "16px",
               background: "rgba(158, 90, 213, 0.20)",
               padding: "20px",
               display: "flex",
               flexDirection: "column",
               justifyContent: "flex-start",
               alignItems: "flex-start",
               textAlign: "left",
               marginBottom: "0",
               minHeight: "48%",
               "& p": {
                  // color: $black2,
                  width: "90%",
               },
               "@media only screen and (max-width: 600px)": {
                  width: "100%",
                  minHeight: "0",
                  "& p": {
                     width: "100%",
                  },
               },
            },
         },

         "@media only screen and (max-width:  768px)": {
            flexDirection: "column",
            gap: "20px",
            marginBottom: "0",

            "& .imageColumn": {
               display: "flex",
               justifyContent: "center",
               alignItems: "center",
               width: "100%",
            },

            "& .featureColumn": {
               width: "100%",
            },
         },
      },
   },

   //tabscards
   cardTabsSection: {
      background: "linear-gradient(180deg, #011C33 0%, #210538 100%)",
      "& .header": {
         display: "flex",
         marginBottom: "64px",
         width: "100%",
         "& span": {
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "5px",
            "@media only screen and (max-width: 600px)": {
               "& img": {
                  height: "30px",
                  width: "30px",
               },
            },
         },
      },
   },
   cardTabsContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "24px",
      width: "100%",
   },
   cardTabsSelectors: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      gap: "30px",
      "@media only screen and (max-width: 600px)": {
         overflow: "auto",
         gap: "15px",
         justifyContent: "flex-start",
         "&::-webkit-scrollbar": {
            display: "none",
         },
      },
   },
   cardTabsSelector: {
      background: "rgba(255, 255, 255, 0.10)",
      padding: "24px",
      width: "32%",
      borderRadius: "16px",
      color: "#fff",
      opacity: "0.5",
      transition: "0.3s ease",
      border: "2px solid transparent",
      cursor: "pointer",
      textAlign: "center",
      "&.active": {
         opacity: "1",
         background:
            "linear-gradient(105deg, rgba(77, 0, 140, 0.50) 0%, rgba(181, 93, 251, 0.50) 100%)",
         border: "2px solid rgba(255, 255, 255, 0.50)",
      },
      "@media only screen and (max-width: 600px)": {
         width: "max-content",
         minWidth: "max-content",
         padding: "12px 8px",
         borderWidth: "1px",
         borderRadius: "6px",
         "&.active": {
            borderWidth: "1px",
         },
      },
   },
   cardTab: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "24px 64px",
      borderRadius: "12px",
      background:
         "linear-gradient(105deg, rgba(77, 0, 140, 0.50) 0%, rgba(181, 93, 251, 0.50) 100%)",
      "@media only screen and (max-width: 600px)": {
         padding: "20px",
         flexDirection: "column",
      },
   },
   cardTabLeft: {
      width: "30%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "16px",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   cardTabRight: {
      width: "65%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   //tabscards

   //hovercards
   singleCardDetailsSection: {
      background: "linear-gradient(180deg, #021D1D 14.84%, #210538 100%)",
      position: "relative",
      "@media only screen and (max-width: 600px)": {},
   },
   singleCardDetails: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "20px",
      "@media only screen and (max-width: 600px)": {
         flexDirection: "column",
      },
   },
   singleCardDetailsLeft: {
      width: "55%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      gap: "15px",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   singleCardDetailsRight: {
      width: "45%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   singleCardDetailsRightImage: {
      width: "100%",
   },

   hoverCardSection: {
      background: "linear-gradient(180deg, #021D1D 0%, #011C33 100%)",
      "& .header": {
         display: "flex",
         marginBottom: "64px",
         width: "100%",
         gap: "32px",
         flexDirection: "column",
         "& h2": {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "5px",
         },
         "& p": {
            width: "80%",
         },
         "@media only screen and (max-width: 600px)": {
            marginBottom: "40px",
         },
      },
   },

   hoverCardContianer: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      gap: "30px",
      "@media only screen and (max-width: 600px)": {
         flexDirection: "column",
         gap: "20px",
      },
   },

   hoverCard: {
      background:
         "linear-gradient(105deg, rgba(10, 47, 79, 0.35) 0%, rgba(37, 118, 187, 0.35) 100%)",
      padding: "16px 24px",
      width: "32%",
      gap: "24px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      borderRadius: "12px",
      opacity: "0.5",
      transition: "0.3s ease",
      cursor: "pointer",
      textAlign: "left",
      transform: "scale(1)",
      "&:hover": {
         transform: "scale(1.1)",
         opacity: "1",
         // padding: '28px 24px',
         background: "linear-gradient(105deg, #0A2F4F 0%, #2576BB 100%)",
      },
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         "&:hover": {
            transform: "scale(1)",
         },
      },
   },

   cardsSection: {
      background: "#021D1D",
      paddingTop: "280px",
      "& .cardImg": {
         "& img": {
            width: "100%",
            height: "100%",
         },
      },
      "@media only screen and (max-width: 600px)": {
         "& .cardImg": {
            width: "100%",
            height: "100%",
            marginBottom: "15px",
            marginTop: "0",
            "& img": {
               width: "100%",
               height: "100%",
            },
         },
      },
   },
   belowText: {
      width: "100%",
      textAlign: "right",
      color: "#6691b7",
      marginTop: "20px",
   },

   //hovercards

   supportBox: {
      top: "90%",
      marginTop: "60px",
      width: "100%",
      display: "flex",
      padding: "40px",
      position: "absolute",
      background: "linear-gradient(90deg, #00266D 0%, #00B39B 100%)",
      // backgroundImage: `url(${benefitBgImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      alignItems: "center",
      borderRadius: "20px",
      backdropFilter: "blur(30px)",
      justifyContent: "space-between",
      "& $broadcastLeftContainer": {
         width: "45%",
         "@media only screen and (max-width: 600px)": {
            width: "100%",
         },
      },
      "@media only screen and (max-width: 600px)": {
         flexDirection: "column",
         width: "94%",
         padding: "15px",
         marginTop: "20px",
         gap: "20px",
         top: "100%",
      },
   },

   broadcastLeftContainer: {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   broadcastRightContainer: {
      width: "40%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },

   zigZagSection: {
      background: "#011C33",
   },

   zigZagContainer: {
      gap: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      "@media only screen and (max-width: 900px)": {
         flexDirection: "column",
      },
   },

   zigZagLeftContainer: {
      gap: "15px",
      width: "45%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      "@media only screen and (max-width: 900px)": {
         width: "100%",
      },
   },
   zigZagRightContainer: {
      gap: "15px",
      width: "45%",
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      "@media only screen and (max-width: 900px)": {
         width: "100%",
      },
   },

   zigZagBgCard: {
      padding: "1px",
      width: "48%",
      background:
         "linear-gradient(180deg,rgba(29, 111, 182, 1) 0%, rgba(206, 233, 255, 0.20) 100%)",
      borderRadius: "16px",
      position: "relative",
      "&:nth-child(2)": {
         top: "20px",
      },
      "&:nth-child(4)": {
         top: "20px",
      },
      '@media only screen and (max-width: 430px)': {
         width: "100%",
         "&:nth-child(2)": {
            top: "0",
         },
         "&:nth-child(4)": {
            top: "0",
         },
      },
   },

   zigZagBox: {
      width: "100%",
      height: "100%",
      gap: "8px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      background: "rgba(1, 28, 51, 1)",
      padding: "32px 24px",
      justifyContent: "flex-start",
      position: "relative",
      backdropFilter: "blur(32px)",
      borderRadius: "16px",
      overflow: "hidden",
      "&.regularCard": {
         // background: "rgba(0, 44, 81, 0.4)",
         "&.glass-effect": {
            "&::before": {
               content: '""',
               position: "absolute",
               width: "100px",
               height: "100px",
               zIndex: "-1",
               background: "radial-gradient(circle, #B458FF 100%)",
               borderRadius: "50%",
               filter: "blur(80px)",
               opacity: "var(--before-opacity, 0)",
               left: "var(--before-left, 0)",
               top: "var(--before-top, 0)",
               transition: "opacity 0.3s ease",
               pointerEvents: "none",
            },
         },
      },
   },

   glowTop: {
      position: "absolute",
      width: "150%",
      height: "30px",
      background:
         "radial-gradient(circle, rgba(29, 111, 182, 0.9) 0%, rgba(29, 111, 182, 0) 70%)",
      borderRadius: "10%",
      filter: "blur(30px)",
      top: "-10px",
      left: "50%",
      transform: "translateX(-50%)",
      pointerEvents: "none",
      zIndex: "0",
   },

   glowBottom: {
      position: "absolute",
      width: "180px",
      height: "180px",
      background:
         "radial-gradient(circle, rgba(29, 111, 182, 0.9) 0%, rgba(29, 111, 182, 0) 70%)",
      borderRadius: "50%",
      filter: "blur(40px)",
      bottom: "-100px",
      left: "-30px",
      pointerEvents: "none",
      zIndex: "-1",
   },

   //flip section
   flipSection: {
      paddingBottom: "260px",
      backgroundPosition: "top",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundImage: `url(${flipSectionBg})`,
      "& .centerContainer": {
         width: "80%",
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         flexDirection: "column",
         margin: "0 auto",
         textAlign: "center",
         "@media only screen and (max-width: 600px)": {
            width: "100%",
         },
      },
      "& #flipCardsSection .card": {
         top: "280px",
         zIndex: 2,
         "@media only screen and (max-width: 600px)": {
            top: "240px",
         },
      },
      "& #flipCardsSection .cardImg": {
         height: "420px",
         overflow: "hidden",
         "& img": {
            height: "100%",
            width: "100%",
            objectFit: "contain",
            objectPosition: "bottom",
         },
         "@media only screen and (max-width: 600px)": {
            height: "220px",
            width: "100%",
         },
      },
      "& #flipCardsSection .transparentButton": {
         "@media only screen and (max-width: 600px)": {
            padding: "10px 16px",
            fontSize: "13px",
         },
      },
      "& .trustedHeading": {
         width: "80%",
         textAlign: "center",
         margin: "0 auto",
         "@media only screen and (max-width: 600px)": {
            width: "100%",
         },
      },
      "@media only screen and (max-width: 600px)": {
          paddingBottom: "200px",
      },
   },
   tabs: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        flexWrap: "wrap",
        justifyContent: "center",
        width: "fit-content",
        margin: "48px auto",
        position: "sticky",
        top: "140px",
        zIndex: 1,
        padding: "12px 20px",
        borderRadius: "20px",
        marginBottom: "60px",
        "@media only screen and (max-width: 600px)": {
            flexWrap: "nowrap",
            overflowX: "auto",
            width: "calc(100% - 40px)",
            marginBottom: "32px",
            justifyContent: "flex-start",
             padding: "12px 0px",
        },
        "&::-webkit-scrollbar": {
            display: "none",
        },
    },
   tabsScrolling: {
      position: "relative",
      top: "auto",
   },
   flipTopHeader: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      margin: "0 auto",
      textAlign: "center",
   },
   fliptab: {
      cursor: "pointer",
      width: "max-content",
      padding: "14px 28px",
      alignItems: "center",
      borderRadius: "14px",
      transition: "0.3s ease",
      border: "1px solid rgba(255, 255, 255, 0.50)",
      "&.active": {
         background: "#FF682A",
         border: "1px solid #FF682A",
         "& p": {
            fontWeight: "600",
         },
      },
      "@media only screen and (max-width: 768px)": {
         minWidth: "max-content",
         padding: "8px 12px",
         borderRadius: "10px",
         "& p": {
            fontSize: "13px",
         },
      },
   },
   flipCard: {
      background: "#fff",
      borderRadius: "32px",
      padding: "40px",
      overflow: "hidden",
      display: "flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "space-between",
      "@media only screen and (max-width: 600px)": {
         flexDirection: "column",
         padding: "20px",
         gap: "20px",
      },
   },
   flipCardLeft: {
      width: "50%",
      display: "flex",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         paddingTop: "0px",
      },
   },
   flipCardRight: {
      width: "50%",
      display: "flex",
      flexDirection: "column",
      gap: "40px",
      alignItems: "center",
      justifyContent: "flex-start",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
         gap: "20px",
      },
   },
   flipCardRightHeader: {
      display: "flex",
      flexDirection: "column",
      gap: "24px",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      width: "100%",
   },
   flipCardPointers: {
      display: "flex",
      gap: "40px",
      flexWrap: "wrap",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      width: "100%",
   },
   flipCardPointer: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      width: "45%",
      "@media only screen and (max-width: 600px)": {
         width: "100%",
      },
   },
   detailCard: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      "@media only screen and (max-width: 900px)": {
         flexDirection: "column",
         gap: "20px",
      },
      "&.detailCard3": {
         "@media only screen and (max-width: 600px)": {
            flexDirection: "column-reverse",
            gap: "32px",
         },
      },
   },
   detailCardLeft: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      gap: "20px",
      width: "auto",
      "&.card2": {
         width: "48%",
         padding: "24px 24px 0",
         display: "grid",
         gridTemplateColumns: "1fr 1fr",
         gap: "12px",
         borderRadius: "16px 16px 0 0",
         position: "relative",
         overflow: "hidden",
      },
      "@media only screen and (max-width: 900px)": {
         width: "80%",
         "&.card2": {
            width: "100%",
            padding: "12px",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
            marginTop: "24px",
         },
      },
      "@media only screen and (max-width: 450px)": {
         "&.card2": {
            gridTemplateColumns: "1fr",
         },
      },
   },
   card2GradientBg: {
      position: "absolute",
      width: "100%",
      height: "80%",
      borderRadius: "16px",
      background: "linear-gradient(358deg, #009A99 1.56%, #89D4D4 100%)",
      top: 0,
      left: 0,
      zIndex: 0,
   },
   detailCardRight: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      gap: "20px",
      width: "48%",
      "@media only screen and (max-width: 900px)": {
         width: "100%",
      },
   },

   swiperCard: {
      padding: "32px 24px",
      borderRadius: "16px",
      height: "250px",
      overflow: "hidden",
      transition: "0.5s ease",
      "& .mainCard": {
         top: "0%",
         height: "-webkit-fill-available",
         display: "flex",
         textAlign: "center",
         alignItems: "center",
         justifyContent: "center",
         flexDirection: "column",
         gap: "24px",
         position: "relative",
         transition: "0.5s ease",
         visibility: "visible",
         opacity: "1",
         "& p": {
            display: "none",
         },
         "@media only screen and (max-width: 800px)": {
            gap: "15px",
            justifyContent: "flex-center",
            "& p": {
               display: "block",
            },
         },
      },
      "& .hoverCard": {
         bottom: "-50%",
         height: "-webkit-fill-available",
         textAlign: "center",
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         flexDirection: "column",
         position: "relative",
         transition: "0.5s ease",
         visibility: "hidden",
         opacity: "0",
         "@media only screen and (max-width: 600px)": {
            display: "none",
         },
      },
      "&:hover": {
         "& .mainCard": {
            top: "-150%",
            visibility: "hidden",
            opacity: "0",
         },
         "& .hoverCard": {
            bottom: "100%",
            visibility: "visible",
            opacity: "1",
         },
      },
      "@media only screen and (max-width: 600px)": {
         padding: "15px",
         "&:hover": {
            "& .hoverCard": {
               display: "none !important",
            },
            "& .mainCard": {
               top: "0% !important",
               visibility: "visible !important",
               opacity: "1 !important",
            },
         },
      },
   },
}));

const AiTextModificationWithCRM = () => {
   // desclaration
   const classes = useStyles();
   const [activeRealWorld, setActiveRealWorld] = useState(0);
   const [cardTabSelector, setCardTabSelector] = useState(0);
   const [activeIndex, setActiveIndex] = useState(0);
   const [tabsPastCards, setTabsPastCards] = useState(false);
   const isManualScroll = useRef(false);

   useEffect(() => {
      const section = document.getElementById("flipCardsSection");
      if (!section) return;
      const observer = new IntersectionObserver(
         ([entry]) => {
            if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
               setTabsPastCards(true);
            } else {
               setTabsPastCards(false);
            }
         },
         { threshold: 0 },
      );
      observer.observe(section);
      return () => observer.disconnect();
   }, []);

   //scrollableCards
   useEffect(() => {
      const cards = document.querySelectorAll("#flipCardsSection .card");

      const observer = new IntersectionObserver(
         (entries) => {
            entries.forEach((entry) => {
               const card = entry.target;
               const currentIndex = Array.from(cards).indexOf(card);

               const updateClasses = (activeIdx) => {
                  cards.forEach((c) => {
                     c.classList.remove(
                        "is-previous-1",
                        "is-previous-2",
                        "is-previous-3",
                        "is-previous-4",
                     );
                  });
                  cards.forEach((c, idx) => {
                     if (idx < activeIdx) {
                        const difference = activeIdx - idx;
                        if (difference <= 4) {
                           c.classList.add(`is-previous-${difference}`);
                        }
                     }
                  });
               };

               // Only auto-update if not manually scrolling
               if (!isManualScroll.current) {
                  if (entry.isIntersecting) {
                     setActiveIndex(currentIndex);
                     updateClasses(currentIndex);
                  } else if (
                     !entry.isIntersecting &&
                     entry.boundingClientRect.top > 0 &&
                     currentIndex > 0
                  ) {
                     setActiveIndex(currentIndex - 1);
                     updateClasses(currentIndex - 1);
                  }
               }
            });
         },
         {
            root: null,
            threshold: 0.3,
            rootMargin: "0px",
         },
      );

      cards.forEach((card) => observer.observe(card));

      return () => observer.disconnect();
   }, []);
   //scrollableCards

   // glowing effect

   useEffect(() => {
      // Select all cards that should have the effect
      const cardsToAnimate = [
         ...document.querySelectorAll(`.${classes.zigZagBox}.regularCard`), // Add regularCards
      ];

      cardsToAnimate.forEach((card) => {
         if (!card) return;

         card.classList.add("glass-effect");

         // Set initial top-right position for the glass effect
         const setInitialPosition = () => {
            const rect = card.getBoundingClientRect();
            const topRightX = rect.width - 150; // Adjust this value to position from right edge
            const topRightY = 0; // Top position

            card.style.setProperty("--before-left", `${topRightX}px`);
            card.style.setProperty("--before-top", `${topRightY}px`);
            card.style.setProperty("--before-opacity", "0.8");
         };

         // Call it initially
         setInitialPosition();

         let lastX = null;
         let lastY = null;

         const handleMouseMove = (e) => {
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            lastX = x;
            lastY = y;

            card.style.setProperty("--before-left", `${x - 75}px`);
            card.style.setProperty("--before-top", `${y - 75}px`);
         };

         const handleMouseEnter = () => {
            if (lastX !== null && lastY !== null) {
               card.style.setProperty("--before-left", `${lastX - 75}px`);
               card.style.setProperty("--before-top", `${lastY - 75}px`);
            }
            card.style.setProperty("--before-opacity", "0.8");
         };

         const handleMouseLeave = () => {
            card.style.setProperty("--before-opacity", "0.8");
         };

         // Store handlers on the card element for cleanup
         card.handlers = {
            mousemove: handleMouseMove,
            mouseenter: handleMouseEnter,
            mouseleave: handleMouseLeave,
            resize: setInitialPosition,
         };

         // Add event listeners
         card.addEventListener("mousemove", handleMouseMove);
         card.addEventListener("mouseenter", handleMouseEnter);
         card.addEventListener("mouseleave", handleMouseLeave);
         window.addEventListener("resize", setInitialPosition);
      });

      // Cleanup
      return () => {
         cardsToAnimate.forEach((card) => {
            if (!card) return;

            const handlers = card.handlers;
            if (handlers) {
               card.removeEventListener("mousemove", handlers.mousemove);
               card.removeEventListener("mouseenter", handlers.mouseenter);
               card.removeEventListener("mouseleave", handlers.mouseleave);
               window.removeEventListener("resize", handlers.resize);
            }
         });
      };
   }, [classes]);

   // glowing effect

   // data

   const tabContentData = [
      {
         tabContent: [
            {
               title: "Fine-tuned replies",
               content: "Rephrase responses to match buyer tone and intent.",
               alt: "AI Communication Assistant for Sales Teams",
            },
            {
               title: "Product clarity",
               content:
                  "Expand replies to explain features or pricing clearly.",
               alt: "AI Communication Assistant for Sales Teams",
            },
            {
               title: "Quick follow-ups",
               content: "Shorten messages while keeping the value intact.",
               alt: "AI Communication Assistant for Sales Teams",
            },
            {
               title: "Personal touch at scale",
               content: "Deliver 1:1-like outreach—faster.",
               alt: "AI Communication Assistant for Sales Teams",
            },
         ],
         img: realWorldImg1,
         alt: "AI Communication Assistant for Sales Teams",
         subtitle:
            "Sales teams use the assistant to fine-tune replies and personalise outreach. It helps build better rapport while saving time on repetitive drafting.",
      },
      {
         tabContent: [
            {
               title: "Confusion-free replies",
               content: "Rewrite messages to reduce misunderstandings.",
               alt: "AI Communication Assistant for Support Teams",
            },
            {
               title: "Tone consistency",
               content: "Keep brand voice steady across all channels.",
               alt: "AI Communication Assistant for Support Teams",
            },
            {
               title: "Aligned teamwork",
               content: "Use smart comments for smooth internal handovers.",
               alt: "AI Communication Assistant for Support Teams",
            },
            {
               title: "Faster resolution",
               content: "Auto-suggested replies improve turnaround time.",
               alt: "AI Communication Assistant for Support Teams",
            },
         ],
         img: realWorldImg2,
         alt: "AI Communication Assistant for Support Teams",
         subtitle:
            "Support agents improve both customer and internal communications using AI. This leads to quicker resolutions and clearer internal collaboration.",
      },
      {
         tabContent: [
            {
               title: "Clearer collaboration",
               content: "Rephrase notes before sharing across teams.",
               alt: "AI Communication Assistant for Marketing Teams",
            },
            {
               title: "Tone-matched messaging",
               content: "Adapt content to suit each campaign.",
               alt: "AI Communication Assistant for Marketing Teams",
            },
            {
               title: "Fast drafting",
               content: "Save time on internal briefs and team updates.",
               alt: "AI Communication Assistant for Marketing Teams",
            },
            {
               title: "Better message flow",
               content: "Improve clarity in every interaction.",
               alt: "AI Communication Assistant for Marketing Teams",
            },
         ],
         img: realWorldImg3,
         alt: "AI Communication Assistant for Marketing Teams",
         subtitle:
            "Marketing teams draft a lot of collaborative content. The AI communication assistant helps simplify team discussions and improve message flow.",
      },
      {
         tabContent: [
            {
               title: "Grammar-perfect summaries",
               content: "Auto-correct tone and structure.",
               alt: "AI Communication Assistant for CRM Admins",
            },
            {
               title: "Quick-scan notes",
               content: "Shorten long entries without losing meaning.",
               alt: "AI Communication Assistant for CRM Admins",
            },
            {
               title: "Clean records",
               content: "Maintain consistency across client data.",
               alt: "AI Communication Assistant for CRM Admins",
            },
            {
               title: "Insight capture",
               content: "Highlight key points clearly in every log.",
               alt: "AI Communication Assistant for CRM Admins",
            },
         ],
         img: realWorldImg4,
         alt: "AI Communication Assistant for CRM Admins",
         subtitle:
            "CRM administrators log important summaries and client insights. The communication assistant ensures every note is complete and clean.",
      },
      {
         tabContent: [
            {
               title: "Step-by-step clarity",
               content: "Expand points into easy-to-follow steps.",
               alt: "AI Communication Assistant for Training Teams",
            },
            {
               title: "Better learner engagement",
               content: "Rephrase notes for clearer understanding.",
               alt: "AI Communication Assistant for Training Teams",
            },
            {
               title: "Tone flexibility",
               content: "Adjust tone for formal or casual formats.",
               alt: "AI Communication Assistant for Training Teams",
            },
            {
               title: "Concise feedback",
               content: "Summarise training input efficiently.",
               alt: "AI Communication Assistant for Training Teams",
            },
         ],
         img: realWorldImg5,
         alt: "AI Communication Assistant for Training Teams",
         subtitle:
            "Training teams often write instructional content or internal feedback.AI powered communication tools help polish that content quickly.",
      },
   ];

   const benefits = [
      {
         title: "Built-in AI sentiment analysis",
         desc: "Turns closed conversations into insights you can act on immediately. No switching tabs, no extra effort.",
         icon: benefitIcon1,
      },
      {
         title: "Trusted by SMEs",
         desc: "Trusted CRM for fast-growing small and mid-sized businesses across industries. Used by teams that value clarity and speed.",
         icon: benefitIcon2,
      },
      {
         title: "Easy to use",
         desc: "Intuitive design that helps your team work faster and stay focused. Every feature is built to support daily workflows.",
         icon: benefitIcon3,
      },
      {
         title: "SME-friendly pricing",
         desc: "Affordable AI tools that deliver practical results without bloated pricing. Perfect for SME budgets.",
         icon: benefitIcon4,
      },
      {
         title: "All-in-one CRM",
         desc: "Complete CRM that merges automation, data, and emotional intelligence. Everything you need to grow in one place.",
         icon: benefitIcon5,
      },
      {
         title: "Privacy first",
         desc: "Privacy- Keeps customer data secure and compliant always. Built with care, scaled with confidence.",
         icon: benefitIcon6,
      },
   ];

   const partners = [
      { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
      { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
      { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
      { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
      {
         icon: partnerIcon6,
         alt: "mustard seed systems corporation - Pepper Cloud Customer",
      },
      {
         icon: partnerIcon7,
         alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
      },
      { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
      { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
      { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
      { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
      { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
      {
         icon: partnerIcon6,
         alt: "mustard seed systems corporation - Pepper Cloud Customer",
      },
      {
         icon: partnerIcon7,
         alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
      },
      { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
   ];

   const faqs = [
      {
         question: "What is an AI communication assistant in Pepper Cloud CRM?",
         answer:
            "An AI communication assistant helps users rewrite, rephrase, expand, or shorten text across inbox replies, comments, and closing notes. It improves message clarity and tone with just one click.",
      },
      {
         question:
            "How does AI powered communication improve team productivity?",
         answer:
            "AI powered communication saves time by generating better text instantly. Teams spend less time editing and more time engaging with leads, customers, and colleagues effectively.",
      },
      {
         question: "Can the communication assistant adjust tone in messages?",
         answer:
            "Yes, the communication assistant allows you to switch between tones—such as friendly, formal, or neutral—making your messages suitable for different audiences.",
      },
      {
         question:
            "Where can I use the AI communication assistant inside the CRM?",
         answer:
            "The AI communication assistant is available in inbox messages, comments, and closing notes. It activates automatically when you start typing in these areas.",
      },
      {
         question:
            "Is AI powered communication useful for internal team collaboration?",
         answer:
            "Absolutely. It helps teams write clearer comments and updates, reducing misunderstandings and promoting faster decision-making internally.",
      },
      {
         question:
            "Can marketing teams benefit from the AI communication assistant?",
         answer:
            "Yes, marketing teams can use the assistant to draft better internal briefs, campaign notes, and emails. It ensures brand tone and message consistency.",
      },
      {
         question:
            "Does the communication assistant support shortening long messages?",
         answer:
            "Yes, the communication assistant has a “shorten” option that condenses lengthy messages without losing meaning—ideal for quick replies and summaries.",
      },
      {
         question: "How does AI powered communication ensure message quality?",
         answer:
            "It automatically checks your message for grammar, tone, and clarity. The tool provides rephrased suggestions that help ensure professional and high-quality communication.",
      },
      {
         question:
            "Is the AI communication assistant helpful for support agents?",
         answer:
            "Definitely. Support teams use it to rewrite replies clearly, maintain a polite tone, and document customer conversations in a structured way.",
      },
      {
         question:
            "How can teams get started with the AI communication assistant?",
         answer:
            "Just start typing in the inbox or comment areas. The AI communication assistant will appear below the text box—click the “AssistAI” button to choose from rephrase, tone change, expand, or shorten.",
      },
   ];

   const flipCards = [
      {
         tab: "AI Assistant",
         background: "linear-gradient(180deg, #31114B 0%, #783CA8 100%)",
         img: flipImg1,
         alt: "AI Assistant for sales and CRM automation",
         heading: "Ai Assistant",
         desc: "The AI communication assistant helps you write faster, clearer, and more confidently. Whether replying to a customer, adding a comment, or closing a ticket, you can rephrase, change tone, expand, or shorten your text in one click. It ensures every message is sharp, on-brand, and ready to send.",
         btnText: "Try text modification",
      },
      {
         tab: "AI CRM",
         background: "linear-gradient(180deg, #783CA8 0%, #09939A 100%)",
         img: flipImg2,
         alt: "CRM assistant for process and teamwork",
         heading: "AI CRM",
         desc: "Pepper Cloud’s AI CRM powers communication with intelligent text support built right into your workflow. It understands context and enhances messages without switching tools. Your team can focus more on conversations and less on editing—every reply becomes professional and efficient.",
         btnText: "Explore AI CRM features",
      },
      {
         tab: "Smart comments",
         background: "linear-gradient(180deg, #2576BB 0%, #0A2F4F 100%)",
         img: flipImg3,
         alt: "AI-powered workflow and CRM automation",
         heading: "Smart comments",
         desc: "Team collaboration becomes smoother with AI powered communication in comment threads. Whether you're sharing updates or assigning tasks, the AI assistant helps you rephrase and polish text instantly. It reduces confusion and ensures every message is clear and aligned.",
         btnText: "Enhance team collaboration",
      },
      {
         tab: "Workflow sync",
         background: "linear-gradient(180deg, #00B39B 0%, #00266D 100%)",
         img: flipImg4,
         alt: "AI-powered CRM platform and dashboards",
         heading: "Workflow sync",
         desc: "Integrate AI edits into your existing workflows using the power of AI CRM. From sales replies to support updates, communication stays consistent and efficient. The assistant supports your daily tasks without interrupting how your team already works. It blends into your tools, making smarter edits without changing your routine.",
         btnText: "Streamline your workflows",
      },
      {
         tab: "Closing notes",
         background: "linear-gradient(180deg, #009A99 0%, #053333 100%)",
         img: flipImg5,
         alt: "Conversational AI scalability",
         heading: "Closing notes",
         desc: "Add a professional touch to every interaction with AI-assisted closing notes. Summarise conversations clearly and quickly using built-in suggestions. It helps your team maintain clean, consistent records without spending extra time on editing. Let AI handle the wrap-up, so your team can move on to the next task faster.",
         btnText: "Make every note count",
      },
   ];

   const swiperCards = [
      {
         icon: swiperIcon1,
         heading: "Text modification and tone control",
         contentOne:
            "Adjust tone, length, and brand voice with AI in every message.",
         gradientOne: "linear-gradient(358deg, #783CA8 0%, #31114B 100%)",
      },
      {
         icon: swiperIcon2,
         heading: "Messages input box with AssistAI",
         contentOne: "Draft responses easily using the AI-powered input box.",
         gradientOne: "linear-gradient(180deg, #053333 0%, #009A99 100%)",
      },
      {
         icon: swiperIcon3,
         heading: "Closing notes and comments panel",
         contentOne:
            "Add quick AI-generated closing notes for better follow-ups.",
         gradientOne: "linear-gradient(180deg, #014957 0%, #028BA6 100%)",
      },
      {
         icon: swiperIcon4,
         heading: "Comment tagging for teamwork",
         contentOne:
            "Tag teammates and keep everyone aligned with AI-assisted comments.",
         gradientOne: "linear-gradient(2deg, #2576BB 0%, #0A2F4F 100%)",
      },
   ];

   return (
      <main>
         <SEO
            title={"AI communication and text modification | Pepper Cloud CRM"}
            pathname={
               "https://peppercloud.com/best-ai-crm-features/ai-text-modification-with-crm"
            }
            keywords="Ai communication,Text modification,Ai communication assistant,Ai powered communication,Communication assistant"
            description={
               "Transform CRM chats with AssistAI. Summarise, rephrase, adjust tone. Try AI communication and text modification book your demo."
            }
            ogData={{
               "og:image": [
                  "/meta/og/1X1/home.png",
                  "/meta/og/1024X512/home.png",
                  "/meta/og/1200X630/home.png",
               ],
            }}
            jsonLd={[
               {
                  "@context": "https://schema.org",
                  "@type": "Organization",
                  name: "Pepper Cloud",
                  legalName: "Pepper Cloud PTE LTD",
                  url: "https://peppercloud.com/",
                  logo: "https://peppercloud.com/icons/logo.png",
                  foundingDate: "2017",
                  address: [
                     {
                        "@type": "PostalAddress",
                        streetAddress: "#04-01/02",
                        addressLocality: "Blk 79 Ayer Rajah Crescent",
                        addressRegion: "SG",
                        postalCode: "139955",
                        addressCountry: "Singapore",
                     },
                     {
                        "@type": "PostalAddress",
                        streetAddress:
                           "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                        addressLocality: "Bengaluru",
                        addressRegion: "KA",
                        postalCode: "560095",
                        addressCountry: "India",
                     },
                  ],
                  contactPoint: {
                     "@type": "ContactPoint",
                     contactType: "customer support",
                     telephone: "+6566562616",
                     email: [
                        "sales@peppercloud.com",
                        "support@peppercloud.com",
                     ],
                  },
                  sameAs: [
                     "https://twitter.com/peppercloudpte",
                     "https://www.linkedin.com/company/peppercloud/",
                     "https://www.facebook.com/PepperCloudPteLtd",
                     "https://www.instagram.com/pepper.cloud/",
                  ],
               },
               {
                  "@context": "https://schema.org",
                  "@type": "VideoObject",
                  name: "AssistAI",
                  description:
                     "Harness the power of Pepper Cloud's AssistAI to simplify conversations, automate tasks, streamline workflows, and more. Save time, improve productivity, and make smarter sales decisions with the best AI CRM for your sales workflow.",
                  thumbnailUrl: [
                     "https://drive.google.com/file/d/11D38QAsWjwxtUae6YnwdP1Y__tusgmRF/view?usp=drive_link",
                  ],
                  uploadDate: "2024-12-02",
                  contentUrl:
                     "https://peppercloud.com/static/aiPageHeroSection-3907c41f7c08dfe21633f203852eebe2.mp4",
                  publisher: {
                     "@type": "Organization",
                     name: "Pepper Cloud",
                     logo: {
                        "@type": "ImageObject",
                        url: "https://d4.alternativeto.net/TylnV9uYJt3KRkoH7m9Qbm-T2kdjqV4X3JgKsTxbTUs/rs:fit:280:280:0/g:ce:0:0/exar:1/YWJzOi8vZGlzdC9pY29ucy9wZXBwZXItY2xvdWQtY3JtXzI0MzM4NS5wbmc.png",
                        width: "",
                        height: "",
                     },
                  },
                  duration: "PT1M12S",
               },
               {
                  "@context": "https://schema.org/",
                  "@type": "FAQPage",
                  mainEntity: [
                     {
                        "@type": "Question",
                        name: "What is an AI communication assistant in Pepper Cloud CRM?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "An AI communication assistant helps users rewrite, rephrase, expand, or shorten text across inbox replies, comments, and closing notes. It improves message clarity and tone with just one click.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "How does AI powered communication improve team productivity?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "AI powered communication saves time by generating better text instantly. Teams spend less time editing and more time engaging with leads, customers, and colleagues effectively.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "Can the communication assistant adjust tone in messages?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Yes, the communication assistant allows you to switch between tones—such as friendly, formal, or neutral—making your messages suitable for different audiences.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "Where can I use the AI communication assistant inside the CRM?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "The AI communication assistant is available in inbox messages, comments, and closing notes. It activates automatically when you start typing in these areas.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "Is AI powered communication useful for internal team collaboration?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Absolutely. It helps teams write clearer comments and updates, reducing misunderstandings and promoting faster decision-making internally.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "Can marketing teams benefit from the AI communication assistant?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Yes, marketing teams can use the assistant to draft better internal briefs, campaign notes, and emails. It ensures brand tone and message consistency.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "Does the communication assistant support shortening long messages?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Yes, the communication assistant has a “shorten” option that condenses lengthy messages without losing meaning—ideal for quick replies and summaries.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "How does AI powered communication ensure message quality?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "It automatically checks your message for grammar, tone, and clarity. The tool provides rephrased suggestions that help ensure professional and high-quality communication.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "Is the AI communication assistant helpful for support agents?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Definitely. Support teams use it to rewrite replies clearly, maintain a polite tone, and document customer conversations in a structured way.",
                        },
                     },
                     {
                        "@type": "Question",
                        name: "How can teams get started with the AI communication assistant?",
                        acceptedAnswer: {
                           "@type": "Answer",
                           text: "Just start typing in the inbox or comment areas. The AI communication assistant will appear below the text box—click the “AssistAI” button to choose from rephrase, tone change, expand, or shorten.",
                        },
                     },
                  ],
               },
            ]}
         />
         <section className={classes.commonHeroSection}>
            <section className={classes.heroSection}>
               <div className="container">
                  <div className={classes.heroSectionContainer}>
                     <motion.h1
                        initial={{ opacity: 1, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="font-wix-semibold font-white font-64"
                     >
                        <span>
                           <LazyImage
                              source={assistAi}
                              alt={"AssistAi - Ai crm"}
                           />
                        </span>{" "}
                        Grow sales with AI communication{" "}
                     </motion.h1>
                     <motion.p
                        initial={{ opacity: 1, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="font-white font-wix-regular font-20"
                     >
                        Streamline your conversations with AI communication.
                        Save hours, keep every reply on-brand, and convert more
                        leads, all inside Pepper Cloud CRM.
                     </motion.p>
                     <Link
                        to="/contact/"
                        className="font-18 font-white font-wix-regular primaryButton"
                     >
                        Book your free demo now
                     </Link>
                     <div className={classes.boxes}>
                        <div className={classes.box}>
                           <img
                              src={heroIcon1}
                              alt="Summarise, rephrase or change the tone in seconds"
                           />
                           <p className="font-18 font-wix-medium font-white">
                              Summarise, rephrase or change the tone in seconds
                           </p>
                        </div>
                        <div className={classes.box}>
                           <img
                              src={heroIcon2}
                              alt="Save hours each week and reply twice as fast"
                           />
                           <p className="font-18 font-wix-medium font-white">
                              Save hours each week and reply twice as fast
                           </p>
                        </div>
                        <div className={classes.box}>
                           <img
                              src={heroIcon3}
                              alt="Win more customers with clear, polished messaging"
                           />
                           <p className="font-18 font-wix-medium font-white">
                              Win more customers with clear, polished messaging
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </section>
         </section>
         <section className={classes.heroSectionImgSection}>
            <div className="container">
               <img src={heroSectionImg2} alt="AI text modification in CRM" />
            </div>
         </section>
         <section className={clsx(classes.singleCardDetailsSection)}>
            <div className="container">
               <div className={classes.singleCardDetails}>
                  <div className={classes.singleCardDetailsRight}>
                     <LazyImage
                        source={singleCardImg}
                        height={"100%"}
                        width={"100%"}
                        alt={"WhatsApp CRM for customer service"}
                        className={classes.singleCardDetailsRightImage}
                     />
                  </div>
                  <div className={classes.singleCardDetailsLeft}>
                     <motion.h2
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-semibold font-56 font-white"
                     >
                        Why do you need an AI communication assistant?
                     </motion.h2>
                     <motion.p
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 font-white mt20"
                     >
                        Without AI communication and text modification tools,
                        your team wastes hours rewriting, fixing tone, and
                        trying to stay consistent. AssistAI helps you summarise
                        chats, rephrase awkward lines, and match your customer’s
                        style, instantly. This means faster replies, clearer
                        conversations, and more deals closed, all while keeping
                        your brand voice strong and professional across every
                        message.
                     </motion.p>
                  </div>
               </div>
            </div>
         </section>
         <section className={classes.benefitSection1}>
            <div className="container">
               <div className="centerContainer">
                  <motion.h2
                     initial={{ opacity: 1, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.3 }}
                     className="font-wix-semibold font-56 font-white"
                  >
                     Benefits of using an AI communication assistant
                  </motion.h2>
                  <motion.p
                     initial={{ opacity: 1, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.3 }}
                     className="font-wix-regular font-20 font-white"
                  >
                     Using the AI communication assistant helps your team save
                     time and stay clear in every reply. It supports better
                     writing, faster onboarding, and smooth AI-powered
                     communication every day.
                  </motion.p>
               </div>

               <div className="benefits">
                  <div className="featureColumn">
                     <div className="featureContainer">
                        <LazyImage
                           source={benefit1Icon1}
                           alt={"Natural language prompts"}
                           className={classes.featureIcon}
                        />
                        <p className="font-wix-semibold font-24 font-white">
                           Increase team productivity
                        </p>
                        <p className="font-wix-medium font-18 font-white">
                           The AI communication assistant reduces manual
                           writing. Teams spend less time drafting replies and
                           more time on high-value work.
                        </p>
                     </div>

                     <div className="featureContainer">
                        <LazyImage
                           source={benefit1Icon2}
                           alt={"Instant CRM actions"}
                           className={classes.featureIcon}
                        />
                        <p className="font-wix-semibold font-24 font-white">
                           Ensure message clarity
                        </p>
                        <p className="font-wix-medium font-18 font-white">
                           With AI-powered communication, replies are simple,
                           clear, and easy for customers to understand—every
                           time.
                        </p>
                     </div>
                  </div>

                  <div className="imageColumn">
                     <LazyImage
                        source={benefit1Img}
                        alt={"AI assistant automating CRM actions"}
                        // alt={listItem.alt}
                     />
                  </div>

                  <div className="featureColumn">
                     <div className="featureContainer">
                        <LazyImage
                           source={benefit1Icon3}
                           alt={"AI assistant panel in CRM"}
                           className={classes.featureIcon}
                        />
                        <p className="font-wix-semibold font-24 font-white">
                           Minimise writing errors
                        </p>
                        <p className="font-wix-medium font-18 font-white">
                           The communication assistant checks tone and grammar,
                           helping your team send polished and professional
                           messages.
                        </p>
                     </div>

                     <div className="featureContainer">
                        <LazyImage
                           source={benefit1Icon4}
                           alt={"AssistAI panel by Pepper Cloud"}
                           className={classes.featureIcon}
                        />
                        <p className="font-wix-semibold font-24 font-white">
                           Simplify daily workflows
                        </p>
                        <p className="font-wix-medium font-18 font-white">
                           All features are built inside Pepper Cloud CRM. You
                           get smooth, AI-powered communication without
                           switching tools.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <section className={classes.zigZagSection}>
            <div className="container">
               <div className={classes.zigZagContainer}>
                  <div className={classes.zigZagLeftContainer}>
                     <motion.h2
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-semibold font-56 font-white"
                     >
                        Why teams need an AssistAI communication assistant?
                     </motion.h2>
                  </div>
                  <div className={classes.zigZagRightContainer}>
                     <div className={classes.zigZagBgCard}>
                        <div className={clsx(classes.zigZagBox, "regularCard")}>
                           <div className={classes.glowTop} />
                           <div className={classes.glowBottom} />
                           <p className="font-64 font-wix-semibold font-white">
                              2x
                           </p>
                           <p className="font-18 font-wix-semibold font-white">
                              faster responses
                           </p>
                        </div>
                     </div>
                     <div className={classes.zigZagBgCard}>
                        <div className={clsx(classes.zigZagBox, "regularCard")}>
                           <div className={classes.glowTop} />
                           <div className={classes.glowBottom} />
                           <p className="font-64 font-wix-semibold font-white">
                              50%
                           </p>
                           <p className="font-18 font-wix-semibold font-white">
                              quicker escalations
                           </p>
                        </div>
                     </div>
                     <div className={classes.zigZagBgCard}>
                        <div className={clsx(classes.zigZagBox, "regularCard")}>
                           <div className={classes.glowTop} />
                           <div className={classes.glowBottom} />
                           <p className="font-64 font-wix-semibold font-white">
                              60%
                           </p>
                           <p className="font-18 font-wix-semibold font-white">
                              less manual editing
                           </p>
                        </div>
                     </div>
                     <div className={classes.zigZagBgCard}>
                        <div className={clsx(classes.zigZagBox, "regularCard")}>
                           <div className={classes.glowTop} />
                           <div className={classes.glowBottom} />
                           <p className="font-64 font-wix-semibold font-white">
                              3x
                           </p>
                           <p className="font-18 font-wix-semibold font-white">
                              more follow-ups logged
                           </p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
         <section className={classes.flipSection}>
            <div className="container">
               <div className="centerContainer">
                  <h2 className="font-56 font-wix-medium font-white">
                     Why Pepper Cloud is the best CRM with an AI assistant
                  </h2>
               </div>
               <div
                  className={clsx(
                     classes.tabs,
                     tabsPastCards && classes.tabsScrolling,
                  )}
               >
                  {flipCards.map((tab, index) => (
                     <div
                        key={tab.tab}
                        className={clsx(
                           classes.fliptab,
                           activeIndex === index && "active",
                        )}
                        onClick={() => {
                           isManualScroll.current = true;
                           setActiveIndex(index);

                           // Get all cards
                           const cards = document.querySelectorAll(
                              "#flipCardsSection .card",
                           );
                           if (cards.length > 0 && cards[index]) {
                              // Get the cumulative scroll position by summing up heights of previous cards
                              let cumulativeScrollPosition = 0;

                              // Sum up heights of all cards before the target card
                              for (let i = 0; i < index; i++) {
                                 const cardHeight =
                                    cards[i].getBoundingClientRect().height;
                                 cumulativeScrollPosition += cardHeight;
                              }

                              // Add the offset of the container
                              const container =
                                 document.getElementById("flipCardsSection");
                              const containerOffset = container
                                 ? container.getBoundingClientRect().top +
                                   window.pageYOffset
                                 : 0;

                              // Final scroll position
                              const scrollPosition =
                                 containerOffset +
                                 cumulativeScrollPosition -
                                 280 + index*36 ; // -100 for padding/offset

                              window.scrollTo({
                                 top: scrollPosition,
                                 behavior: "smooth",
                              });
                           }  

                           setTimeout(() => {
                              isManualScroll.current = false;
                           }, 1000);
                        }}
                     >
                        <p className="font-18 sm:font-16 font-wix-regular font-white">
                           {tab.tab}
                        </p>
                     </div>
                  ))}
               </div>
               <ul
                  id="flipCardsSection"
                  style={{ "--numcards": flipCards.length, paddingLeft: 0 }}
               >
                  {flipCards.map((card, index) => (
                     <li
                        className="card"
                        id={`flip-card-${index}`}
                        key={card.tab}
                        style={{ "--index": index + 1 }}
                     >
                        <div
                           className="card-content"
                           style={{ background: card.background }}
                        >
                           <div className="cardContentData">
                              <h3 className="cardHeading font-wix-medium">
                                 {card.heading}
                              </h3>
                              <p className="cardDesciption">{card.desc}</p>
                              <Link
                                 to="/contact/"
                                 className="transparentButton font-wix-medium font-16 mt10"
                              >
                                 {card.btnText}
                              </Link>
                           </div>
                           <div className="cardImg">
                              <LazyImage source={card.img} alt={card.alt} />
                           </div>
                        </div>
                     </li>
                  ))}
               </ul>
            </div>
            {/* <section className={classes.trustedSection}> */}
            <div className="container">
               <div className="trustedHeading">
                  <motion.h3
                     initial={{ opacity: 1, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.3 }}
                     className="font-wix-semibold font-24 font-white"
                  >
                     Trusted by leading businesses for outstanding efficiency
                  </motion.h3>
               </div>
            </div>
            <Swiper
               className={classes.partnerSlider}
               slidesPerView="auto"
               spaceBetween={60}
               loop={true}
               speed={2000}
               modules={[Autoplay]}
               allowTouchMove={false}
               autoplay={{
                  delay: 100,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: false,
               }}
            >
               {partners.map((partner) => (
                  <SwiperSlide className={classes.partnerSlide}>
                     <img src={partner.icon} alt={partner.alt} />
                  </SwiperSlide>
               ))}
            </Swiper>
            {/* </section> */}

            <div className="container">
               {" "}
               <div className={classes.detailCard}>
                  <div className={classes.detailCardRight}>
                     <motion.h2
                        initial={{ opacity: 1, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-semibold font-56 font-white"
                     >
                        Features of an AI communication assistant
                     </motion.h2>
                     <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 font-white"
                     >
                        The AI communication assistant makes work easier by
                        helping you write, edit, and reply faster.It offers
                        smart tools like text modification, summaries, and
                        real-time suggestions inside your CRM.
                     </motion.p>
                  </div>
                  <div className={clsx(classes.detailCardLeft, "card2")}>
                     <div className={classes.card2GradientBg} />
                     {swiperCards.map((card) => (
                        <div
                           className={classes.swiperCard}
                           style={{
                              background: card.gradientOne,
                              position: "relative",
                              zIndex: 1,
                           }}
                        >
                           <div className="mainCard">
                              <img src={card.icon} />
                              <h4 className="font-20 font-white font-wix-semibold">
                                 {card.heading}
                              </h4>
                              <p className="font-16 font-white font-wix-regular">
                                 {card.contentOne}
                              </p>
                           </div>
                           <div className="hoverCard">
                              <p className="font-16 font-white font-wix-regular">
                                 {card.contentOne}
                              </p>
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
            </div>
         </section>
         <section className={classes.tabsSection}>
            <div className={classes.absoulteCard}>
               <TruestedSection shadow={true} background={true} />
            </div>
            <div className="container">
               <div className="centerContainer">
                  <motion.h2
                     initial={{ opacity: 1, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.3 }}
                     className="font-wix-semibold font-56 font-white"
                  >
                     Application and use cases of the AI communication assistant
                  </motion.h2>
                  <motion.p
                     initial={{ opacity: 1, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     transition={{ duration: 0.3 }}
                     className="font-wix-regular font-20 font-white"
                  >
                     The AI communication assistant in Pepper Cloud CRM empowers
                     teams to communicate smarter and faster. From inbox replies
                     to internal notes, this AI powered communication tool
                     ensures clarity, tone consistency, and time-saving edits
                     across every message touchpoint.
                  </motion.p>
                  <div className={classes.tabsContainer}>
                     <div
                        className={clsx(
                           classes.tab,
                           "font-wix-medium",
                           "font-20",
                           activeRealWorld === 0 && "active",
                        )}
                        onClick={() => setActiveRealWorld(0)}
                     >
                        Sales teams
                     </div>
                     <div
                        className={clsx(
                           classes.tab,
                           "font-wix-medium",
                           "font-20",
                           activeRealWorld === 1 && "active",
                        )}
                        onClick={() => setActiveRealWorld(1)}
                     >
                        Support teams
                     </div>
                     <div
                        className={clsx(
                           classes.tab,
                           "font-wix-medium",
                           "font-20",
                           activeRealWorld === 2 && "active",
                        )}
                        onClick={() => setActiveRealWorld(2)}
                     >
                        Marketing teams
                     </div>
                     <div
                        className={clsx(
                           classes.tab,
                           "font-wix-medium",
                           "font-20",
                           activeRealWorld === 3 && "active",
                        )}
                        onClick={() => setActiveRealWorld(3)}
                     >
                        CRM admins
                     </div>
                     <div
                        className={clsx(
                           classes.tab,
                           "font-wix-medium",
                           "font-20",
                           activeRealWorld === 4 && "active",
                        )}
                        onClick={() => setActiveRealWorld(4)}
                     >
                        Training teams
                     </div>
                  </div>
               </div>
               <div className={classes.tabCard}>
                  <div className={classes.tabCardLeftContainer}>
                     {tabContentData.map(
                        (listItem, index) =>
                           index === activeRealWorld && (
                              <div>
                                 <motion.p
                                    initial={{ opacity: 0, x: -20 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 0.3 }}
                                    className="font-wix-regular font-18 font-white"
                                 >
                                    {listItem.subtitle}
                                 </motion.p>
                                 <div className={classes.tabListContainer}>
                                    {listItem.tabContent.map((item) => (
                                       <motion.div
                                          initial={{ opacity: 0, x: -20 }}
                                          whileInView={{ opacity: 1, x: 0 }}
                                          transition={{ duration: 0.3 }}
                                          className={classes.tabListItem}
                                       >
                                          <LazyImage
                                             source={greenCheckCircle}
                                             className={classes.tabIcon}
                                             alt={item.alt}
                                          />
                                          <div
                                             className={
                                                classes.tabListItemContent
                                             }
                                          >
                                             <p className="font-wix-semibold font-18 font-white">
                                                {item.title}:
                                             </p>
                                             <p className="font-wix-regular font-18 font-white">
                                                {item.content}
                                             </p>
                                          </div>
                                       </motion.div>
                                    ))}
                                 </div>
                              </div>
                           ),
                     )}
                  </div>
                  <div className={classes.tabCardRightContainer}>
                     {tabContentData.map(
                        (listItem, index) =>
                           index === activeRealWorld && (
                              <motion.div
                                 initial={{ opacity: 1, y: 20 }}
                                 whileInView={{ opacity: 1, y: 0 }}
                                 transition={{ duration: 0.3 }}
                                 // className={classes.aiSectionRight}
                              >
                                 <LazyImage
                                    source={listItem.img}
                                    alt={listItem.alt}
                                    width={"100%"}
                                 />
                              </motion.div>
                           ),
                     )}
                  </div>
               </div>
            </div>
         </section>
         <TestimonialSlider
            desc={
               "Discover how businesses are transforming customer engagement with Pepper Cloud."
            }
            heading={"Real stories. Real results."}
            background={"#F8FCFF"}
            noButton={true}
         />

         <div className={classes.wpFaq}>
            <FaqSection
               backgroundImage={faqBg}
               dark={true}
               heading={
                  "Frequently asked questions about the AI communication assistant"
               }
               faqs={faqs}
            />
         </div>
         <section className={classes.commonPageFooterSection}>
            <div className="container">
               <div className="centerContainer">
                  <motion.h2
                     className="font-wix-medium font-56 font-white"
                     initial={{ opacity: 1, y: 30 }}
                     transition={{ duration: 0.5 }}
                     whileInView={{ opacity: 1, y: 0 }}
                  >
                     Turn every conversation into a conversion with AI-powered
                     communication.
                  </motion.h2>
                  <Link
                     className="primaryButton font-18 font-wix-medium font-white"
                     to="/contact/?utm_source=WhatsApp+CRM&utm_medium=Get+started"
                     style={{ padding: "8px 32px" }}
                  >
                     Get started
                  </Link>
               </div>
            </div>
         </section>
      </main>
   );
};

export default AiTextModificationWithCRM;
